import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "tir-pm-task-group_header" }
const _hoisted_2 = { class: "label_sticky" }
const _hoisted_3 = { class: "tir-pm-task-group_icon-wrapper chevron" }
const _hoisted_4 = { class: "curtain__info" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "curtain__title" }
const _hoisted_7 = { class: "tir-pm-task-group_icon-wrapper count" }
const _hoisted_8 = { class: "tir-pm-task-group_controls" }
const _hoisted_9 = { class: "tir-pm-task-group_controls" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "tir-pm-task-group_header--title"
}

import { computed, CSSProperties, inject, onUnmounted, PropType, Ref, ref, watch } from 'vue';
import { ChevronDownIcon, FlagIcon } from 'tir-style-system/icons/solid';
import { DragModel, TirPmDraggable } from '../../tir-pm-kanban';
import { EllipsisHorizontalIcon, PlusIcon } from 'tir-style-system/icons/solid';
import { GroupedTaskItemModel, TaskModel } from '../../tasks-kanban/models';
import { TasksKanbanColumnIndicator } from '../../tasks-kanban/components';
import { TaskDrawerFormDataModel } from '../../task-forms';
import { TaskParameter, TaskParameterTypeEnum } from '@/components';
import { ExtensionModel } from '../../edit-queue-modal/models';
import { HeaderItemModel, ListItemModel } from '../models';
import { TirPmIconView, TirPmTooltipElement } from 'tir-components';
import { ProjectModel } from '@/models';
import { TaskViewElementEnum } from '../enums';
import {
  Bars3BottomLeftIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ClockIcon,
  EstimateTimeIcon,
  EyeIcon,
  PlayCircleIcon,
  RectangleStackIcon,
  TimeSpentIcon,
  UserCircleIcon,
  UserIcon,
} from 'tir-style-system/icons/outline';
import { TasksKanbanGrouppingTypeEnum } from '@/components/tasks-kanban/enums';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-group',
  props: {
  /**Данные о группе */
  group: { type: Object as PropType<GroupedTaskItemModel> },
  /**Размер имени задачи */
  nameWidth: { type: String },
  /**Размеры колонок списка */
  listColumns: { type: Array as PropType<ListItemModel[]> },
  /**Текущий проект */
  currentProject: { type: Array as PropType<ProjectModel[]> },
  /**Тип группировки */
  grouppingType: { type: Number as PropType<TasksKanbanGrouppingTypeEnum> },
  /**Активная сортировка */
  activeSortType: { type: String as PropType<TaskViewElementEnum> },
},
  emits: ["create", "dragComponentOnDrop", "sortingList"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Перетаскиваемый элемент */
const currentDragging = inject<Ref<DragModel<TaskModel>>>('currentDragging');
/**Элемент над которым находится перетаскиваемый объект */
const overDragging = inject<Ref<DragModel<GroupedTaskItemModel>>>('overDragging');
/**Модель для области дропа на верхний уровень */
const dropAreaData = ref(
  new DragModel({
    AllowDrag: false,
    AllowDrop: true,
    Data: props.group,
  }),
);
/**Раскрыт ли список */
const visible = ref(false);
/**Сортируемые элементы */
const sortableTypes = [
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.Difficulty,
  TaskViewElementEnum.Deadline,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
];

/**Кол-во элементов */
const itemsCount = computed(() => props.group?.Items?.length || 0);
/**Заголовки списка */
const headers = computed(() => {
  const header = props.listColumns.map(
    (x, i) =>
      new HeaderItemModel({
        Name: x.Name,
        Type: x.Type,
        Style: {
          width: props.listColumns[i].Width,
        },
        Icon: getIconTypeElement(x.Type),
        StateSort: false,
      }),
  );
  return header;
});
/**Стили элемента заголовка */
const headersStyle = computed(() => ({ left: `calc(${props.nameWidth} + 2.5rem)` }));

/**Отслеживание типа группировки */
watch(
  () => props.grouppingType,
  () => {
    visible.value = props.grouppingType === TasksKanbanGrouppingTypeEnum.None;
  },
  { immediate: true },
);

/**Переключить видимость списка */
const toggleVisible = () => {
  if (props.grouppingType === TasksKanbanGrouppingTypeEnum.None) return;
  visible.value = !visible.value;
};
/**Получить иконку типа элемента шапки */
const getIconTypeElement = (type: TaskViewElementEnum) => {
  switch (type) {
    case TaskViewElementEnum.Author:
      return UserIcon;
    case TaskViewElementEnum.Performers:
      return UserCircleIcon;
    case TaskViewElementEnum.Observers:
      return EyeIcon;
    case TaskViewElementEnum.Difficulty:
      return ChartBarIcon;
    case TaskViewElementEnum.Priority:
      return FlagIcon;
    case TaskViewElementEnum.Type:
      return RectangleStackIcon;
    case TaskViewElementEnum.Deadline:
      return ClockIcon;
    case TaskViewElementEnum.DateCreate:
      return CalendarDaysIcon;
    case TaskViewElementEnum.EstimateTime:
      return EstimateTimeIcon;
    case TaskViewElementEnum.WorkTime:
      return PlayCircleIcon;
    default:
      return Bars3BottomLeftIcon;
  }
};
/**Сброс элемента на верхний уровень */
const onAreaDrop = () => {
  emit('dragComponentOnDrop', dropAreaData.value);
  setTimeout(() => {
    overDragging.value = undefined;
    currentDragging.value = undefined;
  });
};
/**Наведение на область сброса */
const onAreaOver = (isOver: boolean) => {
  overDragging.value = isOver ? dropAreaData.value : undefined;
};
/**Сортировка списка */
const sortingList = (elem: HeaderItemModel) => {
  if (sortableTypes.includes(elem.Type)) emit('sortingList', elem.Type);
};
/**Отправка события для открытия окна с созданием задачи */
const createTask = () => {
  emit(
    'create',
    new TaskDrawerFormDataModel({
      StatusId: props.group?.Status?.Id,
      PriorityId: props.group?.Priority?.Id,
      TypeId: props.group?.Type?.Id,
      PerformerIds: props.group?.Performer?.Id ? [props.group.Performer.Id] : [],
      Tags: props.group?.Tag?.Id ? [props.group.Tag.Id] : [],
    }),
  );
};
/**Данные о статусе/приоритете/тэге */
const badgeData = computed(() => {
  const data = props.group.Status || props.group.Priority || props.group.Tag;
  return new ExtensionModel({
    Name: data.Name,
    Color: data.Color,
  });
});

/**Тип бейджа */
const badgeType = computed(() => {
  if (props.group.Status) return TaskParameterTypeEnum.Status;
  if (props.group.Priority) return TaskParameterTypeEnum.Priority;
  return;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tir-pm-task-group", { 'is-open': visible.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "label",
        onClick: toggleVisible
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(ChevronDownIcon))
          ]),
          (badgeType.value != undefined)
            ? (_openBlock(), _createBlock(_unref(TaskParameter), {
                key: 0,
                preview: "",
                data: badgeData.value,
                type: badgeType.value
              }, null, 8, ["data", "type"]))
            : (_openBlock(), _createBlock(_unref(TasksKanbanColumnIndicator), {
                key: 1,
                grouping: __props.group
              }, null, 8, ["grouping"])),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.currentProject, (project) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(TirPmIconView), {
                class: "curtain__icon",
                size: 24,
                isBordered: false,
                isRounded: ""
              }, {
                mainSlot: _withCtx(() => [
                  _createElementVNode("img", {
                    src: project.ImageUrl,
                    alt: ""
                  }, null, 8, _hoisted_5)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("p", _hoisted_6, _toDisplayString(project.Name), 1),
              _createElementVNode("b", null, "(" + _toDisplayString(__props.group.Items?.length || 0) + ")", 1)
            ]))
          }), 256)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(__props.group.Items?.length || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "tir-pm-task-group_icon-wrapper",
                onClick: _withModifiers(createTask, ["stop"])
              }, [
                _createVNode(_unref(PlusIcon))
              ], 8, _hoisted_10)
            ])
          ])
        ]),
        (visible.value && itemsCount.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "tir-pm-task-group_headers",
              style: _normalizeStyle(headersStyle.value)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value, (header) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: _normalizeStyle(header.Style as CSSProperties)
                }, [
                  _createVNode(_unref(TirPmTooltipElement), {
                    isDisabled: header.Type === _unref(TaskViewElementEnum).Status,
                    width: "max-content",
                    class: "tir-pm-task-group_hint"
                  }, {
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString(header.Name), 1)
                    ]),
                    default: _withCtx(() => [
                      (header.Type === _unref(TaskViewElementEnum).Status)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(header.Name), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(header.Icon), {
                        class: _normalizeClass(["tir-pm-task-group_icon", { 'tir-pm-task-group_icon--active': __props.activeSortType === header.Type }]),
                        onClick: _withModifiers(($event: any) => (sortingList(header)), ["stop"])
                      }, null, 8, ["class", "onClick"]))
                    ]),
                    _: 2
                  }, 1032, ["isDisabled"])
                ], 4))
              }), 256))
            ], 4))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_Transition, { name: "scale_label_content" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["field", { open: !!_unref(currentDragging) }])
        }, [
          _createVNode(_unref(TirPmDraggable), {
            dragModel: dropAreaData.value,
            onDrop: onAreaDrop,
            onOver: onAreaOver,
            class: _normalizeClass(["field-drop_area", {
            open: !!_unref(currentDragging),
            over: !!_unref(currentDragging) && _unref(overDragging)?.Data.Id === dropAreaData.value.Data.Id,
          }])
          }, null, 8, ["dragModel", "class"]),
          _renderSlot(_ctx.$slots, "default")
        ], 2), [
          [_vShow, visible.value]
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

})